export default function InfoModalTxt(props) {

    return (
        <div className="modal-body">
            <h4 className="font-bold text-4xl text-center">{props.title}</h4>
            <br></br>
            <h5 className="font-normal text-xl text-center text-black -mb-8">{props.desc}</h5>
            <br></br>
        </div>
    )
}